import { Grid, Row, Col, FormGroup, FormControl, ControlLabel, Table } from "react-bootstrap";
import LinkButton from "../LinkButton";
import Loader from "../Loader";
import ImagePreview from "../ImagePreview";
import React, { PureComponent } from "react";
import * as menuStatus from "../../enums/menuStatus";
import * as combos from "../../lib/api/combos";
import tableStyles from "../../styles/tableStyles";
import { css } from "aphrodite";
import logger from "../../lib/logger";

const strings = {
    title: "Combos | Habit CMS",
    combos: "Combos",
    filterByName: "Filter by Name:",
    filterByStatus: "Filter by Status:",
    enterText: "Enter text",
    name: "Name",
    category: "Categories",
    status: "Status",
    available: "Available",
    unavailable: "Unavailable",
    edit: "Edit",
};

export default class CombosPage extends PureComponent {
    state = {
        filter: "",
        loading: true,
        combos: [],
        status: menuStatus.all.value,
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = strings.title;
        combos
            .getCombos()
            .then(resp => {
                if (this._isMounted) {
                    this.setState({ combos: resp.combos, loading: false });
                }
            })
            .catch(err => {
                logger.warn(err);
                if (this._isMounted) {
                    this.setState({ loading: false });
                }
            });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _onFilterChange = e => {
        this.setState({ filter: e.target.value });
    };

    _onStatusChange = e => {
        this.setState({ status: e.target.value });
    };

    render() {
        if (this.state.loading) {
            return <Loader />;
        }
        const lowerFilter = this.state.filter.toLowerCase();
        const currentCombos = this.state.combos.filter(c => {
            if (this.state.status === menuStatus.available.value) {
                if (c.status !== menuStatus.available.value) {
                    return false;
                }
            } else if (this.state.status === menuStatus.unavailable.value) {
                if (c.status !== menuStatus.unavailable.value) {
                    return false;
                }
            }
            return (
                (c.name && c.name.toLowerCase().indexOf(lowerFilter) !== -1) ||
                (c.categoryName && c.categoryName.toLowerCase().indexOf(lowerFilter) !== -1)
            );
        });
        return (
            <Grid>
                <Row>
                    <h3>{strings.combos}</h3>
                </Row>
                <Row>
                    <Col md={4}>
                        <FormGroup controlId="filter">
                            <ControlLabel>{strings.filterByName}</ControlLabel>
                            <FormControl
                                type="text"
                                value={this.state.filter}
                                placeholder={strings.enterText}
                                onChange={this._onFilterChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup controlId="status">
                            <ControlLabel>{strings.filterByStatus}</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={this.state.status}
                                onChange={this._onStatusChange}
                            >
                                <option value={menuStatus.all.value}>{menuStatus.all.label}</option>
                                <option value={menuStatus.available.value}>
                                    {menuStatus.available.label}
                                </option>
                                <option value={menuStatus.unavailable.value}>
                                    {menuStatus.unavailable.label}
                                </option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th />
                                    <th>{strings.name}</th>
                                    <th>{strings.category}</th>
                                    <th>{strings.status}</th>
                                    <th>{strings.edit}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentCombos.map(c => (
                                    <tr key={c.id}>
                                        <td
                                            className={css(
                                                tableStyles.imagePreview,
                                                c.isolatedImages128 && c.isolatedImages128.length
                                                    ? null
                                                    : tableStyles.danger,
                                            )}
                                        >
                                            <ImagePreview
                                                height={70}
                                                images={c.isolatedImages128}
                                            />
                                        </td>
                                        <td>{c.name}</td>
                                        <td>{c.categoryName}</td>
                                        <td>
                                            {c.status === menuStatus.available.value
                                                ? menuStatus.available.label
                                                : menuStatus.unavailable.label}
                                        </td>
                                        <td>
                                            <LinkButton bsStyle="primary" to={`/combo/${c.id}`}>
                                                {strings.edit}
                                            </LinkButton>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        );
    }
}
